import { createGtm } from 'vue-gtm'

export default createGtm({
  id: 'GTM-TZ747LC'
})
